import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "open", "onClose", "onDragOver", "onDrop", "maxWidth", "fullWidth", "modalStyles", "hideOverlay", "disableOverlayClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, isValidElement } from 'react';
import { createPortal } from 'react-dom';
import { ignoreEvent, intrinsicComponent } from '../../utils/functions';
import { Size } from './types';
import ModalMenuContext from './modal-menu-context';
import Styled from './modal.styles';
var isValidSingleFragmentChildren = function isValidSingleFragmentChildren(children) {
  return children && /*#__PURE__*/isValidElement(children) && React.Children.count(children) === 1 && children.type === React.Fragment;
};
var Modal = intrinsicComponent(function (_ref, ref) {
  var _children = _ref.children,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    onClose = _ref.onClose,
    onDragOver = _ref.onDragOver,
    onDrop = _ref.onDrop,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? Size.Xs : _ref$maxWidth,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    modalStyles = _ref.modalStyles,
    _ref$hideOverlay = _ref.hideOverlay,
    hideOverlay = _ref$hideOverlay === void 0 ? false : _ref$hideOverlay,
    _ref$disableOverlayCl = _ref.disableOverlayClick,
    disableOverlayClick = _ref$disableOverlayCl === void 0 ? false : _ref$disableOverlayCl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var children = isValidSingleFragmentChildren(_children) ? _children.props.children : _children;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var target = document.querySelector('body');
  useEffect(function () {
    if (open) {
      document.body.classList.add('Modal-open');
    } else {
      document.body.classList.remove('Modal-open');
    }
    return function () {
      document.body.classList.remove('Modal-open');
    };
  }, [open]);
  var handleClose = function handleClose() {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  useEffect(function () {
    var keyListener = function keyListener(ev) {
      if (ev.key === 'Escape') {
        handleClose();
      }
    };
    document.addEventListener('keydown', keyListener);
    return function () {
      return document.removeEventListener('keydown', keyListener);
    };
  });
  var render = function render() {
    return /*#__PURE__*/React.createElement(ModalMenuContext.Provider, {
      value: {
        modalOpened: Boolean(open)
      }
    }, /*#__PURE__*/React.createElement(Styled.Wrapper, {
      style: _objectSpread({}, modalStyles),
      open: Boolean(open),
      ref: ref,
      onDragOver: onDragOver ? onDragOver : ignoreEvent,
      onDrop: onDrop ? onDrop : ignoreEvent
    }, !hideOverlay && /*#__PURE__*/React.createElement(Styled.Overlay, {
      onClick: function onClick() {
        return disableOverlayClick ? null : handleClose();
      },
      open: Boolean(open)
    }), /*#__PURE__*/React.createElement(Styled.Container, _extends({}, rest, {
      maxWidth: maxWidth,
      fullWidth: fullWidth,
      open: Boolean(open)
    }), /*#__PURE__*/React.createElement(Styled.Modal, null, React.Children.map(children, function (child) {
      if ( /*#__PURE__*/isValidElement(child) && child.type.displayName === 'ModalTitle') {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread({
          onClose: handleClose
        }, child.props || {}));
      }
      return child;
    })))));
  };
  return /*#__PURE__*/createPortal(render(), target);
});
export default Modal;